










































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import constants        from '@/constants';
import LineGraph        from '@/components/graph/LineGraph.vue';
import LineGraph3        from '@/components/graph/LineGraph3.vue';
import ShareDialog      from '@/components/ui/ShareDialog.vue';

import { RawLocation, Route } from 'vue-router';

import OrderedPair from '@/models/OrderedPair'
import { DetailGraphLoadingIndicator } from '../graph/LoadingIndicatorConfig';

@Component({
  name: 'SiteMiniDetail',
  components: {
    // LineGraph,
    LineGraph3,
    ShareDialog
  }
})

/**
 * This component is all fucked up...
 *
 * It has params set along with the route that should define what it does and how it loads data,
 * but instead, data is loaded in Main.vue, probably for good reasons, who knows... and then this
 * component just shows the active site's info.
 *
 * But it also relies on shit that's set in the route params to set some global state flags that
 * control whether or not this component has a back button.
 *
 * I don't even know at this point. Back is working and I'm very tired...
 */
export default class SiteMiniDetail extends Vue {

  // Back button present when
  //
  // 1. backUrl is in the store
  // 2. siteNumberWithBackRoute in store AND matches the current siteNumber

  @Prop({ required: false }) readonly backRoute!: RawLocation

  // FIXME RIGHT NOW: unfuck `activeSiteNumber_fromStore` and `siteNumber`
  //
  // This one should be a prop, and the other should be something else
  @Prop({ required: true }) siteNumber!: String;

  loadingIndicatorConfig = DetailGraphLoadingIndicator;

  resizeObserver!: ResizeObserver;

  showValuesFromTooltip = false;
  currentFlow = '';
  flowFromTooltip = '';

  //
  // Lifecycle hooks
  //

  mounted() {
    if (this.$refs.lineGraph) {
      this.resizeObserver = new ResizeObserver(() => {
        (this.$refs.lineGraph as any).resize();
      });
      this.resizeObserver.observe(this.$el);
    }
  }

  /**
   * On unmount
   * - detach resize observer from chart
   */
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  get isSiteRoute() {
    return this.$store.state.uiState.isSiteRoute;
  }

  get isLoadingSite() {
    return this.$store.state.uiState.isLoadingSite;
  }

  // TODO SITE INFO REFACTOR: Reenable fallback to gauge height
  get siteName() {
    return this.$store.state.activeSite.reference.siteName;
  }

  get activeSiteNumber_fromStore() {
    return this.$store.state.activeSite.reference.siteNumber;
  }

  get stateCd() {
    return this.$store.state.activeSite.reference.state;
  }

  get activeFlowVariable() {
    // Discharge is always the active flow variable in this component, unless it doesn't exist
    if (!!this.$store.state.activeSite.data.discharge.lastWeekTimeSeries) {
      return constants.FlowVariables.Discharge;
    }
    return constants.FlowVariables.GaugeHeight;
  }

  get baseTimeSeries() {
    const timeSeries = this.activeFlowVariable === constants.FlowVariables.Discharge ?
      this.$store.state.activeSite.data.discharge.lastWeekTimeSeries : this.$store.state.activeSite.data.gaugeHeight.lastWeekTimeSeries;

    return timeSeries;
  }

  get hasBackRoute() {
    return this.siteNumber === this.$store.state.uiState.siteNumberWithBackRoute && this.$store.state.uiState.backRoute;
  }

  get flowSnapshot() {
    const flow: any = this.showValuesFromTooltip ? this.flowFromTooltip : this.currentFlow;
    let units = this.activeFlowVariable.units
    if (isNaN(flow) || flow === '') {
      units = '';
    }

    return {
      value: flow,
      units
    };
  }

  get echartsTimeSeriesConfig() {
    const timeSeries = this.baseTimeSeries;
    const dataPoints = (timeSeries && timeSeries.data) || [];

    // TODO: extract into graph builder
    let max: Number = 0;
    dataPoints.forEach((dataPoint: OrderedPair) => {
      const asFugginNumber = new Number(dataPoint.y);
        if (asFugginNumber > max) {
          max = asFugginNumber;
        }
      }
    );

    return [{
      dataPoints,
      lineColor : constants.COLORS.OSF_BLUE,
      max
    }]
  }

  handleTooltipUpdated(tooltipData: Array<Record<string, string>>) {
    if (tooltipData.length > 0) {
      this.flowFromTooltip = tooltipData[0].value;
    } else {
      this.flowFromTooltip = '';
    }
    this.showValuesFromTooltip = true;
  }

  handleSetCurrentTooltipValue(snapshotConfig: Record<string, string>) {
    this.currentFlow = snapshotConfig.value;
  }

  goBack() {
    this.$router.push(this.$store.state.uiState.backRoute);
  }

  beforeRouteEnter(to: Route, from: Route, next: Function) {
    next((vm: any) => {

        // Happens in callback like this because *this* isn't defined when beforeRouteEnter
        // runs ('vm' is 'this')
        vm.beforeRoute_Helper(to, from);
      });
  }

  async beforeRouteUpdate(to: Route, from: Route, next: Function) {
    await this.beforeRoute_Helper(to, from, next);
    next();
  }

  async beforeRoute_Helper(to: Route, from: Route, next: Function) {
    // If route has a backUrl param,
    // - set some shit in the store indicating this has the back url
    // - and that's it?
    //
    // We just have to make sure to

    // backRoute is only ever set when site is loaded from search /    search results...
    //
    // And only the first time this component renders in that situation. So the user could open the
    // detail modal, close it, open it again, and backRoute never gets set again. setting it is a
    // flag that means "hey THIS SITE has a back button to THIS ROUTE"



    // REFACTOR: move to Main.vue??? (probably)
    //
    // This logic should all be in Main.vue, not here. Leaving it as is to avoid breaking shit
    // during a refactor.
    if (this.backRoute) {
      await this.$store.dispatch("setBackRoute", this.backRoute);
      await this.$store.dispatch("setSiteNumberWithBackRoute", this.siteNumber);
    }
    // Force open tray
    this.$store.dispatch('setIsTrayOpen', true);
  }

}

